<template>
  <div style="height: 32px;" class="sidebar-logo absolute top-0 left-0 filter invert"
  :class="{ 'collapsed': getSidebarCollapsed }" :style="{'--collapse-transition-duration': `${getSidebarCollapseDuration}ms`}">
    <svg width="32px" height="32px" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"
    class="absolute top-0 left-0">
      <path d="M7.875 4.375H9.625V9.625H4.375V7.875C4.375 5.94125 5.94125 4.375 7.875 4.375Z" fill="black"/>
      <path opacity="0.85" d="M18.375 4.375H11.375V9.625H18.375V4.375Z" fill="black"/>
      <path opacity="0.7" d="M17.5 11.375H11.375V16.625H15.5C16.6046 16.625 17.5 15.7296 17.5 14.625V11.375Z" fill="black"/>
      <path opacity="0.2" d="M23.625 11.375H19.25V14.625C19.25 15.7296 20.1454 16.625 21.25 16.625H23.625V11.375Z" fill="black"/>
      <path opacity="0.1" d="M18.375 18.375H23.625V20.125C23.625 22.0588 22.0588 23.625 20.125 23.625H18.375V18.375Z" fill="black"/>
      <path opacity="0.2" d="M14.625 18.375H11.375V23.625H16.625V20.375C16.625 19.2704 15.7296 18.375 14.625 18.375Z" fill="black"/>
      <path opacity="0.6" d="M20.125 4.375C22.0588 4.375 23.625 5.94125 23.625 7.875V9.625H20.125V4.375Z" fill="black"/>
      <path opacity="0.85" d="M9.625 11.375H4.375V16.625H9.625V11.375Z" fill="black"/>
      <path opacity="0.6" d="M4.375 18.375H9.625V23.625H7.875C5.94125 23.625 4.375 22.0588 4.375 20.125V18.375Z" fill="black"/>
    </svg>
    <svg width="108px" height="32px" viewBox="0 0 95 28" fill="none" xmlns="http://www.w3.org/2000/svg"
    class="logo-name absolute top-0 left-0">
      <path d="M32.3907 12.6819H33.7925V19.2496H35.5092V12.6819H37.667V11.1856H35.4777V10.5084C35.4777 9.95711 35.714 9.72086 36.2652 9.72086H37.667V8.22461H36.0447C34.4855 8.22461 33.7925 8.98061 33.7925 10.4296V11.1856H32.3907V12.6819Z" 
      fill="url(#name-label-gradient)"/>
      <path d="M42.02 19.3441C44.477 19.3441 46.1308 17.6904 46.1308 15.2176C46.1308 12.7606 44.477 11.0911 42.02 11.0911C39.563 11.0911 37.9093 12.7606 37.9093 15.2176C37.9093 17.6904 39.563 19.3441 42.02 19.3441ZM42.02 17.8951C40.5868 17.8951 39.6575 16.7769 39.6575 15.2176C39.6575 13.6584 40.5868 12.5401 42.02 12.5401C43.4533 12.5401 44.3983 13.6584 44.3983 15.2176C44.3983 16.7769 43.4533 17.8951 42.02 17.8951Z" 
      fill="url(#name-label-gradient)"/>
      <path d="M51.5778 11.1856C50.2548 11.1856 49.6091 11.7211 49.1996 12.3984L49.0106 11.1856H47.4986V19.2496H49.1996V15.2019C49.1996 13.9576 49.6878 12.7764 51.1998 12.7764H51.9558V11.1856H51.5778Z" 
      fill="url(#name-label-gradient)"/>
      <path d="M56.4476 19.3441C58.4479 19.3441 59.8024 18.1314 60.0859 16.5406H58.3849C58.1486 17.4384 57.3926 17.9581 56.3531 17.9581C55.0144 17.9581 54.1481 17.0604 54.1009 15.6901V15.5799H60.1804C60.2119 15.3594 60.2276 15.1389 60.2276 14.9341C60.1804 12.5716 58.6211 11.0911 56.2901 11.0911C53.9119 11.0911 52.3211 12.7449 52.3211 15.2334C52.3211 17.7061 53.9119 19.3441 56.4476 19.3441ZM54.1639 14.3356C54.2899 13.1859 55.2191 12.4614 56.3059 12.4614C57.4871 12.4614 58.3219 13.1386 58.4636 14.3356H54.1639Z" 
      fill="url(#name-label-gradient)"/>
      <path d="M65.9183 11.0911C64.6583 11.0911 63.8236 11.6739 63.2881 12.3826L63.0833 11.1856H61.6028V22.3996H63.3038V18.1156C63.8078 18.8401 64.6741 19.3441 65.9183 19.3441C68.1233 19.3441 69.7298 17.7061 69.7298 15.2176C69.7298 12.6346 68.1233 11.0911 65.9183 11.0911ZM65.6348 17.9109C64.2173 17.9109 63.2881 16.7926 63.2881 15.1861C63.2881 13.6269 64.2173 12.5401 65.6348 12.5401C67.0523 12.5401 67.9973 13.6269 67.9973 15.2176C67.9973 16.7926 67.0523 17.9109 65.6348 17.9109Z" 
      fill="url(#name-label-gradient)"/>
      <path d="M71.0928 19.2496H72.7938V8.22461H71.0928V19.2496Z" 
      fill="url(#name-label-gradient)"/>
      <path d="M81.8322 17.7691C81.4857 17.7691 81.3125 17.6589 81.3125 17.2494V14.0206C81.3125 12.1149 80.084 11.0911 77.942 11.0911C75.9102 11.0911 74.5557 12.0676 74.3825 13.6426H76.052C76.178 12.9339 76.8552 12.4614 77.8632 12.4614C78.9815 12.4614 79.6272 13.0126 79.6272 13.9104V14.3986H77.5955C75.3432 14.3986 74.1462 15.3279 74.1462 16.9816C74.1462 18.4779 75.3747 19.3441 77.1387 19.3441C78.446 19.3441 79.265 18.7771 79.8005 17.9581C79.8005 18.7614 80.1785 19.2496 81.281 19.2496H82.1787V17.7691H81.8322ZM79.6272 15.9421C79.6115 17.1864 78.7925 18.0211 77.375 18.0211C76.4457 18.0211 75.8787 17.5486 75.8787 16.8714C75.8787 16.0524 76.4615 15.6586 77.5167 15.6586H79.6272V15.9421Z" 
      fill="url(#name-label-gradient)"/>
      <path d="M85.0979 19.2969L84.7829 20.0844C84.5309 20.7459 84.3734 20.9034 83.7119 20.9034H82.5149V22.3996H84.3419C85.5231 22.3996 85.8696 21.8169 86.3736 20.5096L90.0276 11.1856H88.2164L86.0271 17.3124L83.7749 11.1856H81.9636L85.0979 19.2969Z" 
      fill="url(#name-label-gradient)"/>
      <defs>
        <linearGradient id="name-label-gradient" x1="61.2499" y1="2.62459" x2="61.2499" y2="23.6246" gradientUnits="userSpaceOnUse">
          <stop offset="0.239531"/>
          <stop offset="1" stop-opacity="0.8"/>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ForeplayLogoSidebarIcon',
  computed: {
    ...mapGetters('MiscModule', ['getSidebarCollapsed', 'getSidebarCollapseDuration'])
  }
}
</script>

<style scoped>
.sidebar-logo {
  position: relative;
}
.sidebar-logo.collapsed  {
  width: 32px;
}
.sidebar-logo .logo-name {
  opacity: 1;
  transition: opacity var(--collapse-transition-duration) ease-in-out;
}
.collapsed .sidebar-logo .logo-name {
  opacity: 0;
}
</style>